module.exports = __webpack_public_path__ + "img/M_Read_more_alcoholic.3a81d122.svg";